import React from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';

const ShoppingFormPlaceholder: React.FC<any> = ({ initialData = {}, onSave, onCancel }) => {
  const [title, setTitle] = React.useState(initialData.title || '');
  const [mallType, setMallType] = React.useState(initialData.mall_type || '');
  const [brands, setBrands] = React.useState(initialData.brands ? initialData.brands.join(', ') : '');

  return (
    <View style={styles.wrap}>
      <Text style={styles.heading}>Shopping (占位表单)</Text>
      <TextInput style={styles.input} placeholder="标题" value={title} onChangeText={setTitle} />
      <TextInput style={styles.input} placeholder="商场类型" value={mallType} onChangeText={setMallType} />
      <TextInput style={styles.input} placeholder="品牌(逗号分隔)" value={brands} onChangeText={setBrands} />
      <View style={styles.actions}>
        <TouchableOpacity onPress={() => onCancel && onCancel()} style={[styles.btn, styles.cancel]}>
          <Text>取消</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => onSave && onSave({ title, mall_type: mallType, brands: brands.split(',').map((s: string) => s.trim()) })} style={[styles.btn, styles.save]}>
          <Text style={{ color: '#fff' }}>保存</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { padding: 12 },
  heading: { fontSize: 18, fontWeight: '700', marginBottom: 12 },
  input: { borderWidth: 1, borderColor: '#eee', padding: 8, marginBottom: 8, borderRadius: 6 },
  actions: { flexDirection: 'row', justifyContent: 'flex-end' },
  btn: { padding: 8, borderRadius: 6, marginLeft: 8 },
  cancel: { backgroundColor: '#f3f4f6' },
  save: { backgroundColor: '#0ea5ff' },
});

export default ShoppingFormPlaceholder;
